package puzzlekey

import kotlin.io.encoding.Base64

/**
 * The QR secret (CONTEXT.md): 32 random bytes, written by `keygen` as unpadded base64url. The same text
 * is `assets/key.txt` and the URL's `#fragment`.
 */
object QrSecret {
    const val BYTES = 32

    private val urlSafe = Base64.UrlSafe.withPadding(Base64.PaddingOption.ABSENT)

    fun encode(bytes: ByteArray): String {
        require(bytes.size == BYTES) { "a QR secret is $BYTES bytes, got ${bytes.size}" }
        return urlSafe.encode(bytes)
    }

    /** The secret's bytes, or null when [text] (surrounding whitespace aside) isn't one. */
    fun parse(text: String): ByteArray? =
        runCatching { urlSafe.decode(text.trim()) }.getOrNull()?.takeIf { it.size == BYTES }
}
